import axios from 'axios';
import list from '@/utils/list.js'

export default {
    getMinimalScenarios(projectId) {
      return this.getAllPreferences(projectId)
        .then((responses, reject) => {
            const preferences = responses.data;
            const scenarios = preferences
                .filter(pref =>
                    this.isMinimalScenario(pref.scenario)
                    && !this.isDiscriminatePreference(pref)
                    && this.isOptionPreference(pref)
                )
                .map(pref => pref.scenario);
            const minimalScenarios = list.removeDuplicateById(scenarios);
            return new Promise(resolve => resolve({ data: minimalScenarios }), reject);
        });
    },

    getScenario(projectId, scenarioId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}`);
    },

    updateScenario(projectId, scenario) {
        return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenario.id}`, scenario);
    },

    markAsNoMoreExtendable(projectId, scenario) {
        return this.updateScenario(projectId, {
            ...scenario,
            extend: 'false',
            elements: this.convertElements(scenario.elements)
        });
    },

    convertElements(elements) {
        return elements.map(element => ({elementId: element.id}));
    },

    getScenarioPreferedOptions(projectId, scenarioId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}/preferences/options`);
    },

    getAllPreferences(projectId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences`);
    },

    // @Deprecated prefer getAllPreferences
    getScenarioPreferences(projectId, scenarioId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}/preferences`);
    },

    // @Deprecated prefer createPreference
    createScenarioPreference(projectId, scenarioId, preferences) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}/preferences`,
            preferences);
    },

    createPreferences(projectId, preferences) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences`,
            preferences);
    },

    deleteScenarioPreference(projectId, preferenceId) {
        return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/${preferenceId}`);
    },

    getIncompatibleScenarios(projectId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/incompatibles`);
    },

    createIncompatibleScenario(projectId, newIncompatible) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/incompatibles`, newIncompatible);
    },

    deleteIncompatibleScenario(projectId, incompatibleId) {
        return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/incompatibles/${incompatibleId}`);
    },
    getPreferencesOfOption(projectId, optionId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/options/${optionId}/preferences`);
    },
    getPreferenceById(projectId, preferenceId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/${preferenceId}`);
    },
    clearResolution(projectId, scenarioId) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}/clear-resolutions`);
    },
    clearCombinationResolution(projectId, preferenceId1, preferenceId2) {
        const combination = {
            preferenceId: preferenceId1,
            combinedPreferenceId: preferenceId2,
        };
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/combinations/clear-resolutions`, combination);
    },
    getAllScenarios(preferences) {
        let allScenarios = preferences.map(pref => pref.scenario);
        return list.removeDuplicateById(allScenarios);
    },
    getAllDescendants(parentScenario, allScenarios) {
        if(!parentScenario.nextLevel || parentScenario.nextLevel.length === 0) {
            return [];
        }
        // Direct descendants
        let descendants = allScenarios.filter(sce => parentScenario.nextLevel.includes(sce.id));
        // sub descendants
        parentScenario.nextLevel.forEach(scenarioId => {
            let descendant = allScenarios.find(sce => sce.id === scenarioId);
            if(descendant) {
                descendants.push(...this.getAllDescendants(descendant, allScenarios));
            }
        });
        return descendants;
    },
    combinePreferencesResolved(projectId, preferenceId1, preferenceId2) {
        return this.combinePreferences(projectId, preferenceId1, preferenceId2, false);
    },
    combinePreferences(projectId, preferenceId1, preferenceId2, extend) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/combinations`, 
        {
            "preferenceId": preferenceId1,
            "combinedPreferenceId": preferenceId2,
            "extend": extend
        });
    },
    getAllPreferencesCombinations(projectId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/combinations`);
    },
    getOptionGroups(projectId, scenarioId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}/groups`);
    },

    getWigo(preference, beliefMode) {
        return beliefMode ? preference.wigoBelief : preference.wigo;
    },

    getLogo(preference, beliefMode) {
        return beliefMode ? preference.logoBelief : preference.logo;
    },

    optionsKey(options) {
        return options
            ?.map(option => option.id)
            .sort()
            .join('-') ?? '';
    },

    wigoKey(preference, beliefMode) {
        let wigo = this.getWigo(preference, beliefMode);
        return this.optionsKey(wigo);
    },

    logoKey(preference, beliefMode) {
        let logo = this.getLogo(preference, beliefMode);
        return this.optionsKey(logo);
    },

    discriminateWinningOptions(projectId, preference) {
        const winningOptions = preference.wigo;
        const scenarioElements = preference.scenario.elements;
        const newMinimalScenario = {
            id: '$scenarioRef1',
            name: 'discriminating minimal scenario',
            level: 1,
            elements: [...scenarioElements],
            extend: 'true',
        };
        const preferences = winningOptions.map(wigo => {
            const pref = {
                name: 'discriminating preference',
                scenario: newMinimalScenario,
                wigo: [wigo],
                previousPreferences: [ preference.id ],
            };
            return pref;
        });
        return this.createPreferences(projectId, preferences);
    },

    isMinimalScenario(scenario) {
      return scenario.level === 1;
    },

    isDiscriminatePreference(preference) {
      return this.isMinimalScenario(preference.scenario) && preference.previousPreferences.length > 0;
    },

    isMinimalPreference(preference, beliefMode, allowDiscriminatePreferences = false) {
      return this.isMinimalScenario(preference.scenario)
        && (allowDiscriminatePreferences || !this.isDiscriminatePreference(preference))
        && (beliefMode ? this.isBeliefPreference(preference) : this.isOptionPreference(preference));
    },

    isBeliefPreference(preference) {
      return preference.wigoBelief?.length > 0;
    },

    isOptionPreference(preference) {
      return preference.wigo?.length > 0;
    }
};